export default "__VITE_ASSET__C3FXPWJ6__"